export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
};

// Make sure geocoder is included
/**
 *
 * @param {Function} latlng {latitude: Float, longitude: Float}
 * @param {Function} callback
 */
export const getAddressFromLongLat = (
  latlng,
  saveToCookie = false,
  callback,
  saveAddressComponents = false
) => {
  const geocoder = new google.maps.Geocoder();
  if (!geocoder) {
    return;
  }
  geocoder.geocode({ location: latlng }).then((res) => {
    const addressComponents = res.results[0].address_components;
    let postal = "";
    let city = "";
    let province = "";
    const cookieExpiry = generateCookieExpiry();
    addressComponents.forEach((comp) => {
      if (comp.types.includes("locality")) {
        city = comp.short_name;
      }
      if (comp.types.includes("administrative_area_level_1")) {
        province = comp.short_name;
      }
      if (comp.types.includes("postal_code")) {
        postal = comp.long_name.replace(/ /g, "");
      }
    });
    postal = postal.replace(/(.{3})/g, "$1 ").replace(/.$/, "");

    if (callback && typeof callback === "function") {
      callback(postal);
    }
    if (saveToCookie) {
      deleteCookiesByName("postal");
      document.cookie = `postal=${postal}; expires=${cookieExpiry}; path=/`;
    }

    if (saveAddressComponents) {
      deleteCookiesByName("city");
      deleteCookiesByName("province");
      document.cookie = `city=${city}; expires=${cookieExpiry}; path=/`;
      document.cookie = `province=${province}; expires=${cookieExpiry}; path=/`;
    }
  });
};

export const generateCookieExpiry = () => {
  return new Date(
    new Date().getTime() + 1000 * 60 * 60 * 24 * 365
  ).toGMTString();
};

/**
 * Since multiple cookies with the same name but different paths can exist at the same time,
 * to prevent some cookie fetching issues, we need to delete all duplicates.
 * @param {string} name
 */
export const deleteCookiesByName = (name) => {
  const theCookies = document.cookie.split(";");
  theCookies.forEach((cookie) => {
    const [key, val] = cookie.split("=");
    const keyFormatted = key.replace(/ /g,'')
    if (keyFormatted === name) {
      document.cookie = keyFormatted + "=; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
  });
};

/**
 * Uses the geolocation API and the google maps API.
 * Make sure that the maps.api script it included in the header or this func won't work.
 * @param {Boolean} saveToCookie
 */
export const getUsersCurrentLocation = (
  callback = null,
  saveToCookie,
  saveLatLongToCookies = false,
  saveAddressComponents = false,
) => {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const cookieExpiry = generateCookieExpiry();
      const lat = position.coords.latitude;
      const long = position.coords.longitude;

      if (saveLatLongToCookies) {
        saveLatLongCookies(long, lat);
      }

      const latlng = {
        lat: lat,
        lng: long,
      };
      getAddressFromLongLat(latlng, saveToCookie, callback, saveAddressComponents);
    },
    null,
    {
      enableHighAccuracy: true,
    }
  );
};

/**
 *
 * @param {String} postal
 */
export const getLongAndLatFromPostal = async (postal) => {
  const geocoder = new google.maps.Geocoder();
  if (!geocoder) {
    return;
  }
  const res = await geocoder.geocode({ address: postal, region: "CA" });
  return res;
};

export const saveLatLongCookies = (long, lat) => {
  const cookieExpiry = generateCookieExpiry();
  deleteCookiesByName("latitude");
  deleteCookiesByName("longitude");
  document.cookie = `longitude=${long}; expires=${cookieExpiry}; path=/`;
  document.cookie = `latitude=${lat}; expires=${cookieExpiry}; path=/`;
};
